// extracted by mini-css-extract-plugin
export default {"slideContainer":"_0S9Dy","slide":"TtuU0"};